import { render, staticRenderFns } from "./CustomerHistoricInvoice.vue?vue&type=template&id=e2796fde&lang=pug&"
import script from "./CustomerHistoricInvoice.vue?vue&type=script&lang=js&"
export * from "./CustomerHistoricInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerHistoricInvoice.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
